module.exports = __webpack_public_path__ + "8e53f2600abea3104a272400eaa48377.svg";